import { Col, Row } from 'antd';
import { ReactComponent as TaskCompleteIcon } from "../../../../../assets/svg/icon-task-complete.svg";
import { ReactComponent as TaskCurrentIcon } from "../../../../../assets/svg/icon-task-current.svg";
import cls from 'classnames';
import { useCssInJs } from "../../../../../hooks";
import { useSubTaskListDrawer } from "../../subTaskListPage";
import { useTaskDetailDrawer } from "../index";
import { getSubTaskProgressStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SubTaskProgress(props) {
  var _props$data;
  var prefix = 'sub-task-progress';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getSubTaskProgressStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var openTaskDetail = useTaskDetailDrawer();
  var openSubTaskList = useSubTaskListDrawer();

  // 子流程数据
  var subFlowOrders = (props === null || props === void 0 || (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.subFlowOrders) || [];
  var handleOpenSubTaskDetail = function handleOpenSubTaskDetail(ev, subFlowOrder) {
    ev.preventDefault();

    // console.log(subFlowOrder)
    var _subFlowOrder$singleI = subFlowOrder.singleInstanceFlowOrder,
      singleInstance = _subFlowOrder$singleI === void 0 ? undefined : _subFlowOrder$singleI;
    if (singleInstance) {
      var flowOrderId = singleInstance.flowOrderId,
        taskOrder = singleInstance.currentTaskOrder;
      openTaskDetail({
        taskOrderId: taskOrder === null || taskOrder === void 0 ? void 0 : taskOrder.taskOrderId,
        flowOrderId: flowOrderId
      }).catch(function () {});
    } else {
      openSubTaskList({
        data: subFlowOrder
      }).catch(function () {});
    }
  };
  if (subFlowOrders.length === 0) {
    return null;
  }
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    className: cls(prefix, hashId),
    children: /*#__PURE__*/_jsx(Row, {
      gutter: 16,
      className: "rowContent",
      children: subFlowOrders.map(function (item) {
        var _item$finishedCount = item.finishedCount,
          finishedCount = _item$finishedCount === void 0 ? 0 : _item$finishedCount,
          taskOrderId = item.taskOrderId,
          _item$totalCount = item.totalCount,
          totalCount = _item$totalCount === void 0 ? 0 : _item$totalCount,
          finishTime = item.finishTime,
          createTime = item.createTime,
          instance = item.singleInstanceFlowOrder;
        var isFinished = finishedCount === totalCount;
        var title = '';
        var shouldIndent = false;
        if (instance) {
          var flowName = instance.flowName,
            _instance$flowOrderNa = instance.flowOrderName,
            flowOrderName = _instance$flowOrderNa === void 0 ? '-' : _instance$flowOrderNa;
          shouldIndent = !!flowName;
          title = flowName ? "\u3010".concat(flowName, "\u3011").concat(flowOrderName) : flowOrderName;
        } else {
          title = item.flowName || '-';
        }
        var desc = '';
        if (instance) {
          var _instance$currentTask;
          desc = "\u5F53\u524D\u8282\u70B9\uFF1A".concat(((_instance$currentTask = instance.currentTaskOrder) === null || _instance$currentTask === void 0 ? void 0 : _instance$currentTask.nodeName) || '-');
        } else {
          desc = "\u5171".concat(totalCount, "\u4E2A\uFF0C\u5B8C\u6210").concat(finishedCount, "\u4E2A");
        }
        var help = '';
        if (instance) {
          help = instance.finishTime || instance.createTime || '';
        } else {
          help = finishTime || createTime || '';
        }
        return /*#__PURE__*/_jsx(Col, {
          span: 12,
          className: "colStyle",
          onClick: function onClick(ev) {
            return handleOpenSubTaskDetail(ev, item);
          },
          children: /*#__PURE__*/_jsxs("div", {
            className: "subTaskItemWrap",
            children: [/*#__PURE__*/_jsx("div", {
              className: cls(prefix, hashId, 'subTaskIconWrap'),
              children: isFinished ? /*#__PURE__*/_jsx(TaskCompleteIcon, {}) : /*#__PURE__*/_jsx(TaskCurrentIcon, {})
            }), /*#__PURE__*/_jsxs("div", {
              className: cls(prefix, hashId, 'subTaskContent'),
              children: [/*#__PURE__*/_jsx("p", {
                className: cls(prefix, hashId, 'subTaskTitle'),
                children: title
              }), /*#__PURE__*/_jsx("p", {
                className: cls(prefix, hashId, 'subTaskDesc'),
                children: desc
              }), /*#__PURE__*/_jsx("p", {
                className: cls(prefix, hashId, 'help'),
                children: help
              })]
            })]
          })
        }, taskOrderId);
      })
    })
  }));
}